import { PasswordResetRequestForm } from '@/pages/PasswordResets/RequestForm'

export default function TeamPasswordResetNew() {
  return (
    <PasswordResetRequestForm
      title="チームコーチ パスワード再設定"
      description="登録済みのメールアドレスに再設定リンクを送信します。"
      postPath="/team/password_resets"
      loginPath="/team/login"
    />
  )
}
